import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "correlation_inv",
  "use": "correlation_inv-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"correlation_inv\"><path d=\"M12.99 15.24 17 17.58V22h2v-5.57l-4.02-2.35zm9.22-9.45L18 1.59 13.79 5.8a.996.996 0 1 0 1.41 1.41l1.8-1.8v4.01l-5 2.92-5-2.91V5.41L8.79 7.2c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L6 1.59l-4.21 4.2A.996.996 0 1 0 3.2 7.2L5 5.41v5.16l5.02 2.93L5 16.43V22h2v-4.43l12-7V5.41l1.79 1.79c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol